import Repository from '@/repositories/repository'

const AcuityOverviewRepository = {
  async getAcuityOverviewData(queryParams: any = {}) {
    const params = {
      ...queryParams
    }

    return await Repository('market-analysis', 'page', params)
  }
}

export default AcuityOverviewRepository
